import { render, staticRenderFns } from "./RoomBatchDetail.vue?vue&type=template&id=40732726&scoped=true"
import script from "./RoomBatchDetail.vue?vue&type=script&lang=js"
export * from "./RoomBatchDetail.vue?vue&type=script&lang=js"
import style0 from "./RoomBatchDetail.vue?vue&type=style&index=0&id=40732726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40732726",
  null
  
)

export default component.exports